import ActionButton from '../../app/shared/components/ActionButton';
import TertiaryButton from '../../app/shared/components/Button/TertiaryButton';
import { Authorize } from '../authentication/Authorize';
import { OrderDetailsProductTranslation } from '../localization/SiteTranslation';
import { BuyerPolicy } from '../Policy';
import { ShoppingCartItemBasicInfo } from '../shared/ShoppingCartItemBasicInfo/ShoppingCartItemBasicInfo';
import { ShoppingCartItemPanel } from '../shared/ShoppingCartItemPanel/ShoppingCartItemPanel';
import css from './OrderDetailsProducts/OrderDetailsProducts.css';
import { OrderItemState } from './OrderItemState';

interface OrderItemProps {
  state: OrderItemState;
  translation: OrderDetailsProductTranslation;
}

export const OrderItem = ({ state, translation }: OrderItemProps) => {
  return (
    <ShoppingCartItemPanel
      item={state.item}
      contextCommands={state.contextCommands}
      translation={translation.shoppingCartItemPanel}
    >
      <ShoppingCartItemBasicInfo
        item={{
          code: state.item.configurationCode,
          configurationCodeOrigin: state.item.configurationCodeOrigin,
          quantity: state.item.quantity,
          listPrice: state.item.listPrice,
          salePrice: state.item.salePrice,
        }}
        translation={translation.shoppingCartItemBasicInfo}
      />
      <Authorize policy={BuyerPolicy}>
        <ActionButton command={state.reorderCommand} className={css.reorderButton} buttonElement={TertiaryButton}>
          {translation.reorderButton}
        </ActionButton>
      </Authorize>
    </ShoppingCartItemPanel>
  );
};
